import {Component, OnInit} from "@angular/core";
import {MatDialogRef} from "@angular/material";
import {ProjectService} from "../../services/project.service";
import {NotificationService} from "../../services/notification.service";

@Component({
    selector: 'app-credential-dialog',
    templateUrl: 'credential.component.html',
})
export class CredentialDialogComponent implements OnInit{
    public item: any;
    public id: string;
    public is_new: boolean;

    constructor(
        public dialogRef: MatDialogRef<CredentialDialogComponent>,
        private projectServ: ProjectService,
        private notifServ: NotificationService
    ) {
    }

    ngOnInit(){
    }

    saveCredential(){
        if(this.is_new){

            this.projectServ.addCredential(this.id, this.item).then(
                r => {
                    this.dialogRef.close(true);
                    this.notifServ.sendSuccess( 'Credential has been added');
                }
            )
        }else{
            this.projectServ.updateCredential(this.id, this.item.key, this.item, true).then(
                r => {
                    this.dialogRef.close(true);
                    this.notifServ.sendSuccess( 'Credential has been updated');
                }
            )
        }

    }

}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/dialogs/credential/credential.component.ts